import React from 'react';
import PropTypes from 'prop-types';

import GravityForm from '~/components/GravityForm';

import Panel from '~/components/Panel';
import Row from '~/layout/Row';
import Column from '~/layout/Column';

import BlockSection from '~/components/wrappers/BlockSection';

import {
    GlobalBlockOptions,
    AcfAttributes,
    DefaultGlobalBlockOptions,
    DefaultAcfAttributes
} from '~/utilities/propTypes';

const Form = ({
    formId,
    usePanel,
    attributes = DefaultAcfAttributes,
    globalBlockOptions = DefaultGlobalBlockOptions
}) => {
    return (
        <BlockSection {...{ attributes, globalBlockOptions }}>
            <Row>
                {usePanel ? (
                    <Column spanLargePhone={10} startLargePhone={2} span={12}>
                        <Panel>
                            <GravityForm formId={formId} />
                        </Panel>
                    </Column>
                ) : (
                    <Column span={12}>
                        <GravityForm formId={formId} />
                    </Column>
                )}
            </Row>
        </BlockSection>
    );
};

Form.propTypes = {
    formId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    usePanel: PropTypes.bool,
    attributes: AcfAttributes,
    globalBlockOptions: GlobalBlockOptions
};

export default Form;
